<template>
<m-button
    v-bind="props"
    :label="label"
    :disabled="disabled"
    :class="[$style.button, $style[color]]"
    @click.native="handler" />
</template>

<script>
import mButton from "@/components/mdc/Button.vue";
export default {
    components: { mButton },
    inheritAttrs: false,
    props: {
        color: { type: String, default: "light" },
        label: { type: String, required: true },
        handler: { type: Function, default: () => {} },
        disabled: { type: Boolean, default: false }
    },
    computed: {
        styleType() {
            switch (this.color) {
            case "light":
                return { outlined: true };
            case "primary":
                return {
                    [this.disabled ? "outlined" : "unelevated"]: true
                };
            case "danger":
                return { unelevated: true };
            default:
                return {};
            }
        },
        props() {
            return { ...this.$attrs, ...this.styleType };
        }
    }
};
</script>

<style lang="scss" module>
@use "@material/button";
@use "@material/ripple";
@use "@/assets/scss/variables" as v;

.button:global(.mdc-button) {
    min-width: 80px;
    text-transform: none;
    @include button.height(40px);
    &:global(.mdc-button--unelevated) {
        font-weight: 600;
    }
    :global {
        .mdc-button__ripple {
            @include ripple.states-base-color(#000);
        }
    }
    &.light {
        @include button.ink-color(#000);
    }
    &.danger {
        @include button.container-fill-color(
            (
                default: v.$error-red,
                disabled: v.$error-red
            )
        );
        @include button.ink-color(
            (
                default: #fff,
                disabled: #fff
            )
        );
    }
}
</style>
